import {Component, OnInit, AfterViewInit, ViewChild, ElementRef, Input, Output, EventEmitter} from '@angular/core';
import * as go from 'gojs';
import {Data} from './class/data';
import {Model} from './class/model';
import {Schema} from './class/schema';

import {DataService} from './service/data.service';
import {JsPlumbService} from './service/jsPlumb.service';

@Component({
    selector: 'app-er-diagram',
    templateUrl: './er-diagram.component.html',
    styleUrls: ['./er-diagram.component.scss']
})
export class ErDiagramComponent implements OnInit {

    // private diagram: go.Diagram = new go.Diagram();
    //
    // @ViewChild('diagramDiv')diagramRef: ElementRef;
    //
    // @Input()
    // get tables(): Object[] {
    //   return this.diagram.model.nodeDataArray;
    // }
    //
    // set tables(val: Object[]) {
    //   this.diagram.model.nodeDataArray = val ? val : [];
    // }
    //
    // @Input()
    // set relations(val: Object[]) {
    //   (this.diagram.model as go.GraphLinksModel).linkDataArray = val ? val : [];
    // }
    //
    // @Input() dataTypes: String[];
    //
    // @Output()
    // nodeSelected = new EventEmitter<go.Node | null>();
    //
    // constructor() {
    //   this.dataTypes = [];
    //   const $ = go.GraphObject.make;
    //   this.diagram = new go.Diagram();
    //   this.diagram.initialContentAlignment = go.Spot.Center;
    //   this.diagram.undoManager.isEnabled = true;
    //   this.diagram.addDiagramListener('ChangedSelection', e => {
    //     const node = e.diagram.selection.first();
    //     this.nodeSelected.emit(node instanceof go.Node ? node.data : null);
    //   });
    //   // This template is a Panel that is used to represent each item in a Panel.itemArray.
    //   // The Panel is data bound to the item object.
    //   var fieldTemplate =
    //       $(go.Panel, 'TableRow',  // this Panel is a row in the containing Table
    //           new go.Binding('portId', 'name'),  // this Panel is a "port"
    //           {
    //             background: 'transparent',  // so this port's background can be picked by the mouse
    //             fromSpot: go.Spot.LeftRightSides,  // links only go from the right side to the left side
    //             toSpot: go.Spot.LeftRightSides,
    //             // allow drawing links from or to this port:
    //             fromLinkable: true, toLinkable: true
    //           },
    //           { // allow the user to select items -- the background color indicates whether "selected"
    //             //?? maybe this should be more sophisticated than simple toggling of selection
    //             click: function (e, item) {
    //               // assume "transparent" means not "selected", for items
    //               var oldskips = item.diagram.skipsUndoManager;
    //               item.diagram.skipsUndoManager = true;
    //               if (item.background === 'transparent') {
    //                 item.background = 'dodgerblue';
    //               } else {
    //                 item.background = 'transparent';
    //               }
    //               item.diagram.skipsUndoManager = oldskips;
    //             }
    //           },
    //           $(go.TextBlock,
    //               {
    //                 margin: new go.Margin(2, 2), column: 1, font: 'bold 13px sans-serif',
    //                 editable: true, isMultiline: false,
    //                 // and disallow drawing links from or to this text:
    //                 fromLinkable: false, toLinkable: false
    //               },
    //               new go.Binding('text', 'name').makeTwoWay()),
    //           $(go.TextBlock,
    //               {
    //                 margin: new go.Margin(2, 2), column: 2, font: '13px sans-serif',
    //                 editable: true, isMultiline: false
    //               },
    //               new go.Binding('text', 'dataType').makeTwoWay())
    //       );
    //   // This template represents a whole "record".
    //   this.diagram.nodeTemplate =
    //       $(go.Node, 'Auto', {
    //             isShadowed: true,
    //             shadowColor: '#C5C1AA'
    //           },
    //           new go.Binding('location', 'loc', go.Point.parse).makeTwoWay(go.Point.stringify),
    //           // this rectangular shape surrounds the content of the node
    //           $(go.Shape,
    //               {fill: '#EEEEEE'}),
    //           // the content consists of a header and a list of items
    //           $(go.Panel, 'Vertical', {stretch: go.GraphObject.Fill},
    //               // this is the header for the whole node
    //               $(go.Panel, 'Auto',
    //                   {stretch: go.GraphObject.Horizontal},  // as wide as the whole node
    //                   $(go.Shape,
    //                       {fill: '#1570A6', stroke: null}),
    //                   $(go.TextBlock,
    //                       {
    //                         alignment: go.Spot.Center,
    //                         margin: 3,
    //                         stroke: 'white',
    //                         textAlign: 'center',
    //                         font: 'bold 12pt sans-serif',
    //                         editable: true, isMultiline: false
    //                       },
    //                       new go.Binding('text', 'key').makeTwoWay())),
    //               // this Panel holds a Panel for each item object in the itemArray;
    //               // each item Panel is defined by the itemTemplate to be a TableRow in this Table
    //               $(go.Panel, 'Table',
    //                   {
    //                     name: 'TABLE',
    //                     padding: 2,
    //                     minSize: new go.Size(100, 10),
    //                     defaultStretch: go.GraphObject.Horizontal,
    //                     stretch: go.GraphObject.Fill,
    //                     itemTemplate: fieldTemplate
    //                   },
    //                   new go.Binding('itemArray', 'fields')
    //               )  // end Table Panel of items
    //           )  // end Vertical Panel
    //       );  // end Node
    //   this.diagram.linkTemplate =
    //       $(go.Link,
    //           {toShortLength: 4},  // let user reconnect links
    //           $(go.Shape, {strokeWidth: 1.5}),
    //           $(go.Shape, {toArrow: 'Standard', stroke: null})
    //       );
    //   this.diagram.model =
    //       $(go.GraphLinksModel,
    //           {
    //             nodeDataArray: this.tables || [],
    //             linkDataArray: this.relations || []
    //           });
    //
    //
    //   // also define a context menu for the diagram's background
    //   this.diagram.contextMenu =
    //       $(go.Adornment, 'Vertical',
    //           $('ContextMenuButton',
    //               $(go.TextBlock, 'Undo'),
    //               {
    //                 click: function (e, obj) {
    //                   e.diagram.commandHandler.undo();
    //                 }
    //               },
    //               new go.Binding('visible', '', function (o) {
    //                 return o.diagram.commandHandler.canUndo();
    //               }).ofObject()),
    //           $('ContextMenuButton',
    //               $(go.TextBlock, 'Redo'),
    //               {
    //                 click: function (e, obj) {
    //                   e.diagram.commandHandler.redo();
    //                 }
    //               },
    //               new go.Binding('visible', '', function (o) {
    //                 return o.diagram.commandHandler.canRedo();
    //               }).ofObject()),
    //           // no binding, always visible button:
    //           $('ContextMenuButton',
    //               $(go.TextBlock, 'New Node'),
    //               {
    //                 click: function (e, obj) {
    //                   e.diagram.startTransaction('new node');
    //                   e.diagram.model.addNodeData({key: 'entity', fields: [{name: 'item', dataType: 'String'}], loc: '0 0'});
    //                   e.diagram.commitTransaction('new node');
    //                 }
    //               })
    //       );
    //
    //   // this is a bit inefficient, but should be OK for normal-sized graphs with reasonable numbers of items per node
    //   const findAllSelectedItems = () => {
    //     let items = [];
    //     for (let nit = this.diagram.nodes; nit.next();) {
    //       const node = nit.value;
    //       const table = node.findObject('TABLE');
    //       if (table) {
    //         for (let iit = table['elements']; iit.next();) {
    //           const itempanel = iit.value;
    //           if (itempanel.background !== 'transparent') {
    //             items.push(itempanel);
    //           }
    //         }
    //       }
    //     }
    //     return items;
    //   };
    //   // Override the standard CommandHandler deleteSelection behavior.
    //   // If there are any selected items, delete them instead of deleting any selected nodes or links.
    //   this.diagram.commandHandler.canDeleteSelection = () => {
    //     // true if there are any selected deletable nodes or links,
    //     // or if there are any selected items within nodes
    //     return go.CommandHandler.prototype.canDeleteSelection.call(this.diagram.commandHandler) ||
    //         findAllSelectedItems().length > 0;
    //   };
    //   this.diagram.commandHandler.deleteSelection = () => {
    //     const items = findAllSelectedItems();
    //     if (items.length > 0) {  // if there are any selected items, delete them
    //       this.diagram.startTransaction('delete items');
    //       for (let i = 0; i < items.length; i++) {
    //         const panel = items[i];
    //         const nodedata = panel.part.data;
    //         const itemarray = nodedata.fields;
    //         const itemdata = panel.data;
    //         const itemindex = itemarray.indexOf(itemdata);
    //         this.diagram.model.removeArrayItem(itemarray, itemindex);
    //       }
    //       this.diagram.commitTransaction('delete items');
    //     } else {  // otherwise just delete nodes and/or links, as usual
    //       go.CommandHandler.prototype.deleteSelection.call(this.diagram.commandHandler);
    //     }
    //   };
    //
    // }
    //
    // ngOnInit() {
    //
    // }
    //
    // ngAfterViewInit(){
    //     this.diagram.div = this.diagramRef.nativeElement;
    // }

    data: Data;
    myModel: Model;
    schema: Schema;
    pY: number;
    models = [];
    schemas = [];
    @Input() tables;
    @Input() relationTables = [];
    relations = [];
    pos_x = 10;
    pos_y = 0;
    id = 0;


    constructor(private dataService: DataService, private jsPlumbService: JsPlumbService, private el: ElementRef) {
        //this.myModel = new Model();
        //this.data = this.dataService.data;
        this.data = new Data();
        //this.jsPlumbService.init();
    }

    ngAfterViewInit() {
        //this.jsPlumbService.initModel(this.myModel);
        //this.jsPlumbService.init();
        //this.populateTables();
    }

    ngAfterViewChecked() {
        //this.populateTables();
        if (this.dataService.flg_repaint) {
            this.dataService.flg_repaint = false;
            this.jsPlumbService.repaintEverything();
        }
    }

    async ngOnInit() {
        this.jsPlumbService.init();
        this.populateTables();
    }


    createModel(table) {
        this.myModel = new Model();
        if (this.id !== 0 && this.id % 5 === 0) {
            this.pos_x = 10;
            this.pos_y = this.pos_y + 300;
        }
        this.myModel.name = table['tableName'];
        this.myModel.display_name = table['tableName'];
        this.myModel.use_soft_delete = false;
        this.myModel.pos_x = this.pos_x;
        this.myModel.pos_y = this.pos_y;


        for (const field of table['fields']) {
            let schema = new Schema();
            schema.name = field['attributeName'];
            schema.display_name = field['attributeName'];
            schema.type = field['type'];
            schema.input_type = 'text';
            schema.unique = field['required'];
            schema.parent_id = this.myModel.id;
            this.myModel.schemas.push(schema);
        }

        this.models.push(this.myModel);
        //this.dataService.addModel(this.myModel);
        this.myModel.id = this.data.getNewModelId();
        this.data.models.push(this.myModel);
        this.pos_x = this.pos_x + 200;
        this.id = this.id + 1;
        //this.jsPlumbService.init();

    }


    getSortOrder(prop) {
        return function (a, b) {
            if (a[prop].length > b[prop].length) {
                return 1;
            } else if (a[prop].length < b[prop].length) {
                return -1;
            }
            return 0;
        };
    }


    createRelationModels(table, posX, posY) {
        this.myModel = new Model();
        this.myModel.name = table['tableName'];
        this.myModel.display_name = table['tableName'];
        this.myModel.use_soft_delete = false;
        this.myModel.pos_x = posX;
        this.myModel.pos_y = posY;


        for (const field of table['fields']) {
            let schema = new Schema();
            schema.name = field['attributeName'];
            schema.display_name = field['attributeName'];
            schema.type = field['type'];
            schema.input_type = 'text';
            schema.unique = field['required'];
            schema.parent_id = this.myModel.id;
            this.myModel.schemas.push(schema);
        }

        this.models.push(this.myModel);
        //this.dataService.addModel(this.myModel);
        this.myModel.id = this.data.getNewModelId();
        this.data.models.push(this.myModel);
        //this.pos_x = this.pos_x + 200;
        //this.id = this.id + 1;
    }


    createRelationGroups(relationGroups) {
        let posX = 10;
        let posY = 0;
        let count = 0;

        for (const relationGroup of relationGroups) {
            posX = 10;
            count = 0;
            for (const child of relationGroup['children']) {
                let filtered_tables = this.relationTables.filter((v, i) => v.tableName === child);
                if (filtered_tables.length > 0) {
                    const table = filtered_tables[0];
                    this.createRelationModels(table, posX, posY);
                    posY = posY + 300;
                }
            }
            let filtered_tables = this.relationTables.filter((v, i) => v.tableName === relationGroup['parent']);
            if (filtered_tables.length > 0) {
                const table = filtered_tables[0];
                posX = 400;
                this.pY = posY / 4;
                this.createRelationModels(table, posX, this.pY);
            }
        }
        this.pos_y = posY;
    }

    populateTables() {
        this.data = new Data();
        this.dataService.data = this.data;
        let relationGroups = [];
        let relationModels = [];
        this.relationTables.sort(this.getSortOrder('foreignKeys'));
        if (this.relationTables.length === 1) {
            this.createModel(this.relationTables[0]);
        }
        for (const table of this.relationTables) {
            relationModels = [];
            for (const relation of table['foreignKeys']) {
                let temp = {
                    sourceModel: relation['PKTABLE_NAME'],
                    targetModel: relation['FKTABLE_NAME']
                };
                relationModels.push(relation['PKTABLE_NAME']);
                this.relations.push(temp);
            }
            if (table['foreignKeys'].length) {
                let temp = {
                    parent: table['tableName'],
                    children: relationModels
                };
                relationGroups.push(temp);
            }


            //this.createModel(table);
        }
        this.createRelationGroups(relationGroups);

        for (const relation of this.relations) {
            this.dataService.addOneToManyRelation(this.data.getModelByName(relation['sourceModel']), this.data.getModelByName(relation['targetModel']));
        }


        for (const table of this.tables) {
            this.createModel(table);
        }
    }

    generateTable() {
        this.dataService.addModel(this.models[this.id]);
        this.id = this.id + 1;
    }

    // ngOnDestroy() {
    //     this.jsPlumbService.destroyModel(this.myModel);
    // }

    // private editModel():void{
    //     this.bsModalRef = this.bsModalService.show( ModalModelComponent, {initialState:{
    //             mode: 'edit',
    //             model: this.myModel,
    //             use_laravel_auth: this.dataService.data.use_laravel_auth
    //         }});
    // }
    //
    // private deleteModel(){
    //     if( confirm('Want to delete ' + this.myModel.name +'?') ){
    //         this.dataService.deleteModel( this.myModel.id );
    //     }
    // }
    //
    // private addSchema():void{
    //     var schema = new Schema();
    //     schema.parent_id = this.myModel.id;
    //     if(this.dataService.data.use_laravel_auth){
    //         schema.nullable = true;
    //     }
    //     this.bsModalRef = this.bsModalService.show( ModalSchemaComponent, {initialState:{
    //             mode: 'create',
    //             schema: schema,
    //             use_laravel_auth: this.dataService.data.use_laravel_auth,
    //             parent_model: this.myModel
    //         }} );
    // }

    // private startDrag(): void {
    //     this.jsPlumbService.toggleDraggable(this.myModel);
    // }
    //
    // private endDrag(): void {
    //     this.jsPlumbService.toggleDraggable(this.myModel);
    //
    //     // record position
    //     let style_left = this.el.nativeElement.querySelectorAll('#' + this.myModel.getElementId())[0].style.left;
    //     let style_top = this.el.nativeElement.querySelectorAll('#' + this.myModel.getElementId())[0].style.top;
    //     this.myModel.pos_x = parseInt(style_left, 10);
    //     this.myModel.pos_y = parseInt(style_top, 10);
    // }

    // ngAfterViewInit() {
    // }

}
